<template>
    <div>
        <el-row>
            <el-col :span='24'>
                <el-steps :active="active" simple>
                    <el-step title="填写企业信息" icon="el-icon-edit"></el-step>
                    <el-step title="上传企业资料" icon="el-icon-upload"></el-step>
                    <el-step title="上传子企业资料" icon="el-icon-upload"></el-step>
                </el-steps>
            </el-col>
        </el-row>
        <el-row >
            <el-col :span="24" >
                <div v-if='active==0' class="contentBox">
                        <div class="content">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                                <el-form-item label="企业logo" prop="resource">
                                    <el-upload
                                        class="avatar-uploader"
                                        v-model="ruleForm.resource"
                                        action="https:///oaapi.dianpiaobao.com/upload/fastdfsUpload"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                       >
                                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="企业名称" prop="name">
                                    <el-input v-model="ruleForm.name"></el-input>
                                </el-form-item>
                                <el-form-item label="企业简称" prop="region" >
                                    <el-input v-model="ruleForm.region"></el-input>
                                </el-form-item>
                                <el-form-item label="行业分类" prop="delivery" >
                                    <el-input  v-model='this.$store.state.title'></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <!-- <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button> -->
                                    <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

<!-- --------------------------------------------------------------------------------------------------------------------------------- -->

                    <div v-if="active==1" >
                        <div  class="uploadBox" >
                            <div class="uploadItem" v-for="(it,index) in uploadList" :key="index">
                                <p class='uploadP'>{{it.name}}</p>
                                <el-upload
                                    class="upload-demo"
                                    drag
                                    style="width:200px"
                                    :limit=1
                                    :ref="it.type"
                                    :headers="myheader"
                                    :data="it.type"
                                    :before-upload='handleBefore'
                                    :action="it.id"
                                    :http-request="billSettlement"
                                    >
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                    <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                </el-upload>
                            </div>
                        </div>
                        <div class="butBox">
                            <el-button type="primary" @click="nextButton()">下一步</el-button>
                        </div>
                    </div>

<!-- --------------------------------------------------------------------------------------------------------------------------------- -->

                        <div v-if="active==2">
                                <div class="timeBox">
                                        <el-date-picker
                                            v-model="value"
                                            type="year"
                                            value-format="yyyy"
                                            @change='choseeDate'
                                            placeholder="选择年">
                                        </el-date-picker>
                                </div>
                                <div  class="uploadBox" >
                                    <div class="uploadItem" v-for="(it,index) in childUploadList" :key="index">
                                        <p class='uploadP'>{{it.name}}</p>
                                        <el-upload
                                            class="upload-demo"
                                            drag
                                            :limit=1
                                            :ref="it.type"
                                            :headers="myheader"
                                            :before-upload='handleChildBefore'
                                            :data="it.type"
                                            :action="it.id"
                                            :http-request="CmpSubsidiaryo"
                                            >
                                            <i class="el-icon-upload"></i>
                                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                            <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                        </el-upload>
                                    </div>
                                </div>
                                <!-- <div class="uploadItem1">
                                </div> -->
                                <!-- <div class="butBox">
                                    <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                                    <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                                </div> -->
                        </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    computed: {
        myheader(){
            return {
                "Content-Type":"multipart/form-data"
            }
        }
    },
    data(){
        return{
            active:0,
            imageUrl: '',
            imgtitle:'',
            value:'',
            componyName:'',
            ruleForm: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: '',
                resource: '',
                desc: '国企',
            },
            rules: {
                name: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                ],
                region: [
                    { required: true, message: '请输入统一信用代码', trigger: 'blur' },
                ],
                delivery: [
                    { required: false, message: '请输入行业分类', trigger: 'blur' },
                ],
                resource: [
                    { required: false, message: '请选择经营状态', trigger: 'blur' }
                ],
            },
            uploadList:[{name:'票据结算',id:'/shangPiao/importCmpYsyfpj',type:'zx'},{name:'财务概况',id:'/shangPiao/importCmpTbCwgk',type:'zc'},
                        {name:'费用情况',id:'/shangPiao/importCmpTbFyqk',type:'zv'},{name:'债券融资',id:'/shangPiao/importCmpTbZqrz',type:'zb'}
                        ],
            childUploadList:[
                {name:'1001、子企业情况',id:'/shangPiao/importCmpSubsidiary',type:'zqy'},{name:'1002、表决权不足半数但能控制的子企业',id:'/shangPiao/importCmpSubsidiary',type:'bjqbz'},
                {name:'1003、重要非全资子公司',id:'/shangPiao/importCmpSubsidiaryFinance',type:'1'},{name:'1004、本期新纳入合并范围的主体',id:'/shangPiao/importCmpSubsidiary',type:'bqxnr'},
                {name:'1005、非同一控制下的合并企业',id:'/shangPiao/importCmpSubsidiary',type:'ftykzxdhbqy'},{name:'1006、本期不再纳入合并范围的子公司',id:'/shangPiao/importCmpSubsidiaryBqbznrhbfw',type:'ad'},
                {name:'1007、有半数以上表决权但未能控制的子企业',id:'/shangPiao/importCmpSubsidiaryBsysbjq',type:'af'},
                {name:'1009、应收账款情况',id:'/shangPiao/importCmpYsk',type:'aq'},{name:'1010、预付账款情况',id:'/shangPiao/importCmpYfzk',type:'aw'},
                {name:'1011、应收股利情况',id:'/shangPiao/importCmpYsgl',type:'ae'},{name:'1012、其他应收款情况',id:'/shangPiao/importCmpYskOther',type:'ar'},
                {name:'1013、长期股权投资明细',id:'/shangPiao/importCmpGqtz',type:'at'},
                {name:'1015、重要联营与合同公司财务报表',id:'/shangPiao/importCmpSubsidiaryFinance',type:'2'},{name:'1016、在建工程情况',id:'/shangPiao/importCmpDevelop',type:'1016'},
                {name:'1017、开发支出情况',id:'/shangPiao/importCmpDevelop',type:'1017'},{name:'1018、商誉与减值损失情况',id:'/shangPiao/importCmpGoodwill',type:'ay'},
                {name:'1019、应收&预付账款情况',id:'/shangPiao/importCmpYfAndYsk',type:'au'},{name:'1020、对内对外担保情况',id:'/shangPiao/importCmpGuarantee',type:'ai'},
                {name:'1021、关联方交易情况',id:'/shangPiao/importCmpRelevance',type:'ao'},{name:'1022、僵尸企业名单',id:'/shangPiao/importCmpJiangShi',type:'ap'}
            ],
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.title = this.ruleForm.region;
                    let json = {};
                    json.companyName = this.ruleForm.name;
                    // this.componyName = this.ruleForm.name
                    json.stockShortName = this.ruleForm.region;
                    json.industry= this.$store.state.title;
                    json.logo = this.imgtitle;
                    this.ajax.post('/shangPiao/cmpAdd',{bizContent: json})
                    .then(
                        result=>{
                        if(result.data.status=='0000'){
                            this.motherVal=this.ruleForm.name
                            this.$message('企业信息填写成功');
                            this.active = 1;
                            }
                        }
                    )
                } else {
                return false;
                }
            });
        },
        handleAvatarSuccess(res, item) {
            const fileObj = item.raw
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            this.ajax.post('/upload/fastdfsUpload',form)
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.imageUrl = URL.createObjectURL(item.raw);
                            this.imgtitle = result.data.data
                        }
                    }
            )
        },
        handleBefore(file){
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 10;
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if(!isLt2M){
                this.$message.error('上传模板大小不能超过 10MB');
                return false;
            }
        },
        handleChildBefore(file){
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 10;
            if(this.value == ''){
                this.$message.error('请先选择年份');
                return false;
            }
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if(!isLt2M){
                this.$message.error('上传模板大小不能超过 10MB');
                return false;
            }
        },

        ///////////////////////////////////母企业导入
        billSettlement (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('mgsmc', this.motherVal)
            let formTwo = JSON.stringify(form)
            let url = item.action
            this.ajax.post(url,form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs[item.data].clearFiles()
                                this.$message(result.message);
                            }
                        }
            )
        },

        /////////////////////////////////子企业导入
        CmpSubsidiaryo (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            form.append('file', fileObj)
            form.append('mgsmc', this.motherVal)
            form.append('date', this.value)
            let type = item.data
            form.append('importtype', type)
            // 文件对象
            let formTwo = JSON.stringify(form)
            let url = item.action
                this.ajax.post(url,form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs[item.data].clearFiles()
                                this.$message(result.message);
                            }
                        }
            )
        },
        // choseeDate(){
        //     this.childUploadList.map((it,index)=>{
        //         this.$refs[it.type].clearFiles()
        //     })
        // },
        nextButton(){
            this.active = 2
        }
    }
}
</script>
<style scoped>

.contentBox{
    width: 100%;
    text-align: center;
    margin-top: 15px;
}
.content{
    width: 50%;
    margin: auto;
}
.conP{
    position: absolute;
    left: 190px;
}
.uploadBox{
    width: 100%;
    overflow: hidden;
}
.butBox{
    width: 100%;
    text-align: center;
}
.el-upload-dragger{
    width:260px!important;
}
.timeBox{
    height: 60px;;
    margin-left: 3%;
    margin-top: 15px;
}
.uploadItem{
    float: left;
    height: 300px;;
    width: 30%;
    margin-left: 3%;
    margin-bottom: 15px;
}
.uploadP{
    color: #343C4EFF;
    font-size: 14px;
    font-weight: 600;
    margin: 5px 0;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
    border: 1px solid #eee;
    margin: 20px 0;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/page/bussinessticket/projectmessage.vue